/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import { DocumentWindow }        from './document.window';
import { DocumentWindowManager } from './document.window.manager';
import { Logger }                from '@/util/logger';
import { BlobService }           from '@/services/blob.service';
import { AuthenticationService}  from '@/services/authentication.service';
import { IdeService}             from '@/services/ide.service';
import { JSONBrowserMetadata }   from './json.browser.metadata';

import * as $                    from 'jquery';

import JSONEditor, {JSONEditorOptions} from "jsoneditor";
import {first} from "rxjs/operators";
import KeyDownEvent = JQuery.KeyDownEvent;
import KeyUpEvent = JQuery.KeyUpEvent;

/**
 *
 * @class JsonBrowserWindow
 *
 * @brief window for text and JSON editing
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class JsonBrowserWindow extends DocumentWindow {

  /** access to the virtual file system */
  private blobber:           BlobService = null;

  /** access to user authentication */
  private auth:    AuthenticationService = null;

  /** access to user authentication */
  private ide:                IdeService = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the current search pattern */
  private key:                 string = '';

  /** the editor mode */
  private mode:                string = 'json';

  /** the actual editor */
  private editor:          JSONEditor = null;

  /** if they gave us a string which is already JSON (stringified), then decode instead of load */
  private readonly jsonData:      any = null;

  /** standard constructor */
  constructor(
       meta: JSONBrowserMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[JSONBrowserWindow] constructing...');

    this.manager     = manager;
    this.auth        = this.manager.authService();
    this.blobber     = this.manager.blobService();
    this.ide         = this.manager.ideService();

    if (meta.mode == 'direct') {

      this.key      = meta.label;
      this.mode     = 'json';

      if (!meta.jsonData) {

        this.jsonData = JSON.parse(meta.key);

      } else {

        this.jsonData = meta.jsonData;
      }

    } else {

      this.key  = meta.key;
      this.mode = meta.mode;
    }

    this.showBrowser();
  }

  /** restore the search view (on current 'focus') */
  public showBrowser() {

    Logger.debug(`[JSONBrowserWindow] => ${this.key} : ${this.mode} ...`);

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[JSONBrowserWindow] missing hosting container (${this.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="json_editor_${this.meta.id}" class="json_editor_tab">
</div>
`);

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`json_editor_${this.meta.id}`) as HTMLElement;

      if (dom) {

        clearInterval(checkExist);

        Logger.debug(`[JSONBrowserWindow] init ...`);

        const options: JSONEditorOptions = {
          mode: this.mode === 'text' ? 'text' : 'tree',
          modes: [
            'tree',
            'view',
            'form',
            'text',
            'preview',
            'view'
          ],

          onModeChange: (newMode, oldMode) => {

            Logger.debug(`[JSONBrowserWindow] mode changed! `, newMode, ' <= ', oldMode);

            if (newMode === 'text') {

              this.updateFocus(this.key, 'text');

            } else {

              this.updateFocus(this.key, 'json');
            }

            this.addSaveButton();
          }
        };

        this.editor = new JSONEditor(dom, options);

        /* load the blob if there is on e*/

        this.loadBlob(this.key, this.mode);

        /*
         * Hack Alert! Unfortunately "the chosen one", doesn't have great support for life cycle events,
         * such as "editor ready", nor does it have an obvious API entry point anywhere for adding custom
         * tool buttons to its tool bar.
         *
         * So...we set a timeout function to come back and manually insert a Save button into its toolbar
         * so we can allow the user to save the blob back to the blob manager.  This allows them to do
         * "raw JSON editing"...if they really want to. We don't want them to...but until our train editor
         * is fully ready, this gives them a way to edit.
         *
         */

        Logger.debug(`[JSONBrowserWindow] waiting for mode menu item to exist...`);

        const checkModeExit = setInterval(() => {

          const modeButton: JQuery = $(`#json_editor_${this.meta.id} div.jsoneditor-modes`);

          if ($(modeButton).is('div')) {

            Logger.debug(`[JSONBrowserWindow] mode menu item exists!`);

            /* its there */

            clearInterval(checkModeExit);

            this.addSaveButton();

          } /* end of node div exists check */

        }, 100); /* interval/polling for mode button to exist */

        $(`#json_editor_${this.meta.id}`).parents('.dockspan-tab-content').keydown((e: KeyDownEvent) => {

          /* block the Escape key, so they don't accidentally reload the tab */

          if (e.key.toLowerCase() === 'escape') {

            Logger.debug(`[JSONBrowserWindow] blocking Escape key (down tab-content).`);

            e.preventDefault();
            e.stopPropagation();

            return false;
          }
        });

        $(`#json_editor_${this.meta.id}`).keyup((e: KeyUpEvent) => {

          Logger.debug(`[JSONBrowserWindow] blocking Escape key (up).`);

          e.preventDefault();
          e.stopPropagation();

          return false;
        });

        $(`#json_editor_${this.meta.id}`).keydown((e: KeyDownEvent) => {

          /* block the Escape key, so they don't accidentally reload the tab */

          if (e.key.toLowerCase() === 'escape') {

            Logger.debug(`[JSONBrowserWindow] blocking Escape key (down).`);

            e.preventDefault();
            e.stopPropagation();

            return false;
          }

          if (e.ctrlKey && (e.key.toLowerCase() == 's')) {

            /* add */

            this.saveBlob();

            e.preventDefault();
            e.stopPropagation();

            return false;

          }
        });

      } /* end of dom is ready check */

    }, 100); /* interval/polling for dom to exist */

  }

  public addSaveButton() {

    if (this.key.trim() === '') {

      /* can't save, no blob to save back to */

      return ;
    }

    /* add our save button after the mode button (and before the search input) */

    const modeButton: JQuery = $(`#json_editor_${this.meta.id} div.jsoneditor-modes`);
    const saveButton: string = `
<div id="jsoneditor-save-button_${this.meta.id}" class="jsoneditor-save-button ">
<i class="far fa-save"></i>
</div>`;

    $(modeButton).after(saveButton);

    /* add the save behavior */

    $(`#jsoneditor-save-button_${this.meta.id}`).on('click', () => {

      this.saveBlob();

    });
  }

  public save() {

    this.saveBlob();
  }

  /** helper to save whatever is in the editor back to blob manager */
  public saveBlob() {

    /* fetch the text to save to the blob key */

    const text: string = this.editor.getText();
    const save: JQuery = $(`#jsoneditor-save-button_${this.meta.id}`);

    Logger.debug(`[JSONBrowserWindow] saving (${this.key}) text sz=${text.length}...`);

    /* disable the save button during long operation... */

    $(save).addClass('editorbusy');

    /* do the save ... */

    this.blobber.update(this.key, text)
      .pipe(first())
      .subscribe(
        () => {

          $(save).removeClass('editorbusy');

          Logger.debug('[JSONBrowserWindow] scenario saved.');

        },
        error => {

          $(save).removeClass('editorbusy');

          Logger.error('[JSONBrowserWindow] can not save scenario: ', error);

        });

  }

  /**
   * load the given remote blob content as JSON into the editor.  In 'direct' mode, we just load
   * the object from memory.
   */
  private loadBlob(key: string, mode: string) {

    if (this.jsonData) {

      Logger.debug(`[JSONBrowserWindow] loading (direct): `, this.jsonData);

      this.editor.set(this.jsonData);

      this.updateFocus(key, mode);

      return ;
    }

    /* do the normal pull of the blob from the blob manager and then display */

    if (key.trim() === '') {

      Logger.debug(`[JSONBrowserWindow] loading (empty).`);

      /* just clear the editor */

      this.editor.setText('{}');

      return ;
    }

    Logger.debug(`[JSONBrowserWindow] loading: `, key);

    this.blobber.contents(key)
      .pipe(first())
      .subscribe(
        (content: string) => {

          try {

            if (mode === 'text') {

              try {

                this.editor.setText(content);

              } catch (error) {

                Logger.error(`[JSONBrowserWindow] exception loading text, parse error?`, error);

              }

            } else {

              try {

                const json: any = JSON.parse(content);

                this.editor.set(json);

              } catch (error) {

                Logger.error(`[JSONBrowserWindow] can not load as JSON`, error, ` ...will try as text...`);

                /* fall back to text mode */

                mode = 'text';
                this.editor.setText(content);

              }
            }

            this.updateFocus(key, mode);

          } catch(error) {

            Logger.error(`[JSONBrowserWindow] problem loading JSON: `, error);
          }
        },
        (error) => {

          Logger.error(`[JSONBrowserWindow] can't find content ${key}: `, error);
        });

  }

  /** update the focus to current */
  private updateFocus(key: string, mode: string) {

    this.mode   = mode;
    this.key    = key;

    let keyBase = key.substring(key.lastIndexOf('/') + 1);

    if(!keyBase || keyBase === '' ) {

      keyBase = key;
    }

    this.title  = `${keyBase}`;

    this.editor.focus();
  }

}
